import { useState, type FormEvent } from 'react';
import { guestbookSeed } from '@/mocks/wedding';

type Entry = (typeof guestbookSeed)[number];

function today() {
  const now = new Date();
  return `${now.getFullYear()}. ${String(now.getMonth() + 1).padStart(2, '0')}. ${String(now.getDate()).padStart(2, '0')}`;
}

export default function GuestbookSection() {
  const [entries, setEntries] = useState<Entry[]>(guestbookSeed);
  const [name, setName] = useState('');
  const [side, setSide] = useState('신랑 측');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const onSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const trimmedName = name.trim();
    const trimmed = message.trim();
    if (!trimmedName || !trimmed) {
      setError('이름과 축하 메시지를 모두 입력해 주세요.');
      return;
    }
    setEntries((prev) => [
      { id: `local-${Date.now()}`, name: trimmedName, side, message: trimmed, date: today() },
      ...prev,
    ]);
    setError('');
    setName('');
    setMessage('');
  };

  return (
    <section className="section alt" id="guestbook">
      <div className="section-head">
        <p className="stamp" data-reveal>
          09 — 방명록
        </p>
        <h2 data-reveal>
          축하의 마음을
          <br />
          <em className="accent">한 줄</em> 남겨 주세요
        </h2>
        <p className="sub" data-reveal>
          남겨 주신 글은 두 사람에게 오래도록 남는 선물이 됩니다.
        </p>
      </div>

      <div className="gb-grid">
        <form className="gb-form" onSubmit={onSubmit}>
          <div className="field">
            <label htmlFor="gb-name">이름</label>
            <input
              id="gb-name"
              name="gb-name"
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="성함"
              maxLength={20}
            />
          </div>
          <div className="field">
            <label>구분</label>
            <div className="radio-row">
              <label className="radio-pill">
                <input
                  type="radio"
                  name="gb-side"
                  value="신랑 측"
                  checked={side === '신랑 측'}
                  onChange={() => setSide('신랑 측')}
                />
                <span>신랑 측</span>
              </label>
              <label className="radio-pill">
                <input
                  type="radio"
                  name="gb-side"
                  value="신부 측"
                  checked={side === '신부 측'}
                  onChange={() => setSide('신부 측')}
                />
                <span>신부 측</span>
              </label>
            </div>
          </div>
          <div className="field">
            <label htmlFor="gb-message">축하 메시지</label>
            <textarea
              id="gb-message"
              name="gb-message"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              placeholder="따뜻한 축하의 한마디를 남겨 주세요"
              maxLength={200}
            />
          </div>
          {error ? <p className="form-status err">{error}</p> : null}
          <button type="submit" className="cta">
            방명록 남기기
            <i className="ri-quill-pen-line" aria-hidden="true" />
          </button>
        </form>

        <div className="gb-list">
          {entries.map((e) => (
            <article className="gb-item" key={e.id} data-reveal>
              <div className="gb-item-head">
                <span className="gb-name">{e.name}</span>
                <span className="gb-side">{e.side}</span>
              </div>
              <p className="gb-msg">{e.message}</p>
              <p className="gb-date">{e.date}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}